import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_PROGRAMS: ITitles = {
    icon: 'sync',
    title: 'Tus programas',
    description: 'Gestiona y mantente al día con todos tus programas',
}